import { visT } from "views/components/visualizations/visualizationTranslation";
import HeatmapVisualization from "views/components/visualizations/heatmap/HeatmapVisualization";
import HeatmapVisualizationConfig, {
  COLORSCALES
} from "views/logic/aggregationbuilder/visualizations/HeatmapVisualizationConfig";
import { defaultCompare } from "logic/DefaultCompare";
import {
  areAtLeastNGroupingsConfigured,
  areAtLeastNMetricsConfigured
} from "views/components/visualizations/validations";
const validate = (formValues) => {
  const errors = [];
  if (!areAtLeastNGroupingsConfigured(formValues, 2)) {
    errors.push("Heatmap requires at least two groupings.");
  } else {
    const groupingDirections = formValues.groupBy.groupings.map((grouping) => grouping.direction);
    if (!groupingDirections.includes("row") || !groupingDirections.includes("column")) {
      errors.push("Groupings must include row and column groupings.");
    }
  }
  if (!areAtLeastNMetricsConfigured(formValues, 1)) {
    errors.push("At least one metric must be configured.");
  }
  return errors.length > 0 ? { type: errors.join(" ") } : {};
};
const heatmap = {
  type: HeatmapVisualization.type,
  get displayName() {
    return visT("vis_types.heatmap");
  },
  component: HeatmapVisualization,
  config: {
    fromConfig: ({
      autoScale,
      colorScale,
      reverseScale,
      defaultValue,
      useSmallestAsDefault,
      zMax,
      zMin
    } = HeatmapVisualizationConfig.empty()) => ({
      autoScale,
      colorScale,
      reverseScale,
      defaultValue,
      useSmallestAsDefault,
      zMax,
      zMin
    }),
    toConfig: ({
      autoScale = false,
      colorScale,
      reverseScale = false,
      useSmallestAsDefault,
      zMax,
      zMin,
      defaultValue
    }) => {
      const [finalZMin, finalZMax] = autoScale ? [void 0, void 0] : [zMin, zMax];
      return HeatmapVisualizationConfig.create(
        colorScale,
        reverseScale,
        autoScale,
        finalZMin,
        finalZMax,
        useSmallestAsDefault,
        defaultValue
      );
    },
    createConfig: () => ({ colorScale: "Viridis", autoScale: true }),
    fields: [
      {
        name: "colorScale",
        get title() {
          return visT("vis_common.color_scale");
        },
        required: true,
        type: "select",
        options: [...COLORSCALES].sort(defaultCompare)
      },
      {
        name: "reverseScale",
        type: "boolean",
        get title() {
          return visT("vis_common.reverse_scale");
        }
      },
      {
        name: "autoScale",
        type: "boolean",
        get title() {
          return visT("vis_heatmap.auto_scale");
        }
      },
      {
        name: "zMin",
        type: "numeric",
        get title() {
          return visT("vis_heatmap.min");
        },
        required: true,
        isShown: (values) => !(values == null ? void 0 : values.autoScale)
      },
      {
        name: "zMax",
        type: "numeric",
        get title() {
          return visT("vis_heatmap.max");
        },
        required: true,
        isShown: (values) => !(values == null ? void 0 : values.autoScale)
      },
      {
        name: "useSmallestAsDefault",
        type: "boolean",
        get title() {
          return visT("vis_heatmap.use_smallest_as_default");
        }
      },
      {
        name: "defaultValue",
        type: "numeric",
        get title() {
          return visT("vis_heatmap.default_value");
        },
        isShown: (values) => !(values == null ? void 0 : values.useSmallestAsDefault),
        required: false
      }
    ]
  },
  validate
};
export default heatmap;
